import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import clsx from 'clsx';
import { TitleCard } from '../QualityPage/MetricsSection/MetricsHelpfullComponents';
import apiService from '../../services/apiService';


export const SyncCard = ({
  deploymentData,
  tooltipMessage,
  title,
  arrayOfConfigs,
  projectId,
  selectedProject,
  onNext
}) => {
  const [selectedConfig, setSelectedConfig] = useState({ ...deploymentData });
  const [deploymentStatus, setDeploymentStatus] = useState('loading');

    
  useEffect(() => {
    setSelectedConfig(deploymentData);
  }, [deploymentData]);


  if (deploymentStatus === 'settled') {
    return (
      <div style={{ width: '50%', margin: '0.1rem' }}>
        <TitleCard title={title} tooltipMessage={tooltipMessage} />
        <div
          style={{
            padding: '1rem',
            border: 'solid',
            borderBottomLeftRadius: '0.5rem',
            borderBottomRightRadius: '0.5rem',
            borderColor: '#0c4d82',
            height: 'auto',
            display: 'grid',
            gridTemplateRows: '2fr 3fr 1fr'
          }}
        >
            <section
            >
              <h2>Synchronize to github</h2>
            <p>
              Before deploying your project, you need to select the desired server and then
              synchronize your project with GitHub, ensuring that it is up to date and reflects the
              latest changes you&apos;ve made. Once you have done that, you can then deploy it to the
              desired server.
              <br/><br/>
              If you want to download you project, you can choose localhost.
            </p>
            </section>
          <section
            style={{
              display: 'grid',
              gridTemplateRows: '1fr 1fr 1fr'
            }}
          >
            {' '}
            {selectedConfig && <DeployFlag selectedConfig={selectedConfig} />}
            {selectedConfig && (
              <ServerSelection
                arrayOfConfigs={arrayOfConfigs}
                selectedConfig={selectedConfig}
                setSelectedConfig={setSelectedConfig}
                projectId={projectId}
                selectedProject={selectedProject}
              />
            )}
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 3fr', alignItems: 'center' }}>
              <span style={{ color: '#0c4d82' }}>Project Url: </span>
              {selectedConfig?.url && <span>&nbsp;{selectedConfig.url}</span>}
            </div>
          </section>
          <section
            style={{
              display: 'grid',
              gridTemplateColumns: '1fr 1fr',
              gap: '40%',
              alignItems: 'center',
              justifyItems: 'center'
            }}
          >
            <CancelButton selectedProject={selectedProject}/>
            <SyncButton onNext={onNext} selectedConfig={selectedConfig}/>
          </section>
        </div>
      </div>
    );
  }
  if (deploymentStatus === 'loading')
    return (
      <div style={{ width: '50%', margin: '0.1rem' }}>
        <TitleCard title={title} tooltipMessage={tooltipMessage} />
        <div
          style={{
            padding: '1rem',
            border: 'solid',
            borderBottomLeftRadius: '0.5rem',
            borderBottomRightRadius: '0.5rem',
            borderColor: '#0c4d82',
            height: '75%',
            display: 'grid',
            gridTemplateRows: '2fr 1fr'
          }}
        >
          <Spinner projectIdToDeploy={projectId} setDeploymentStatus={setDeploymentStatus} />{' '}
        </div>
      </div>
    );
    
  return null;
};

export const DeployFlag = ({ selectedConfig }) => {
  const [deployFlag, setDeployFlag] = useState(false);
  useEffect(() => {
    if (!selectedConfig.serverIpAddress) return;
    if (selectedConfig.serverName === 'local') setDeployFlag(false);
    else {
      apiService
        .doAction({
          url: `${selectedConfig.url}/hello`,
          method: 'GET'
        })
        .then((res) => {
          setDeployFlag(res.status === 200);
        })
        .catch(() => setDeployFlag(false));
    }
  }, [selectedConfig]);
  return (
    <div style={{ display: 'grid', gridTemplateColumns: '1fr 3fr', alignItems: 'center' }}>
      <span style={{ color: '#0c4d82' }}>Server Status: </span>
      <div>
        <span
          style={{
            height: '1rem',
            width: '1rem',
            backgroundColor: deployFlag ? 'green' : 'red',
            borderRadius: '50%',
            display: 'inline-block'
          }}
        />
        <span>&nbsp; {deployFlag ? 'Online' : 'Offline'}</span>
      </div>
    </div>
  );
};

const ServerSelection = ({
  arrayOfConfigs,
  selectedConfig,
  setSelectedConfig,
  projectId,
  selectedProject
}) => {
  const optionsArray = arrayOfConfigs.map((config) => (
    <option key={`${config._id}`} value={config._id}>
      {config.serverName} {config.name}
    </option>
  ));

  const upgradeProject = async (deployConfigId) => {
    if (selectedProject === -1) return;
    const projects = JSON.parse(localStorage.getItem('data'));
    return apiService
      .updateProject3(projectId, { deployConfiguration: deployConfigId })
      .then((res) => apiService.getDeployConfig(res.data.deployConfiguration))
      .then((res) => {
        projects[selectedProject].deployConfiguration = res;
        localStorage.setItem('data', JSON.stringify(projects));
        return res;
      })
      .catch((error) => {
        throw error;
      });
  };

  async function handleSelection(event) {
    event.preventDefault();
    try {
      upgradeProject(event.target.value).then((configId) => {
        setSelectedConfig((prev) => {
          if (configId) return configId;
          return prev;
        });
      });
    } catch (error) {
      console.log(error);
    }
  }

  return (
    <div style={{ display: 'grid', gridTemplateColumns: '1fr 3fr', alignItems: 'center' }}>
      <span style={{ color: '#0c4d82' }}>Deploy server: </span>
      {selectedConfig?._id && (
        <select
          value={selectedConfig._id}
          onChange={handleSelection}
          style={{ borderWidth: '0', width: '40%', minWidth: 'fit-content' }}
        >
          {optionsArray}
        </select>
      )}
    </div>
  );
};

const SyncButton = ({ onNext, selectedConfig }) => {
    const [sync, setSync] = useState('Download');
    useEffect(() => {
        if (selectedConfig.serverName === 'local') setSync('Download');
        else {
            setSync('Synchronize');
        }
      }, [selectedConfig]);

  return (
    <button
      type="button"
      className={clsx('cleanCssButton', 'teamselector')}
      onClick={() => onNext(selectedConfig)}
      style={{
        color: 'white',
        backgroundColor: '#0c4d82',
        border: '0.2rem solid #0c4d82',
        borderRadius: '0.5rem',
        width: '75%'
      }}
    >
        {sync}
    </button>
  );
};

function checkActionsStatus(actions) {
  if (actions.filter((action) => action.status !== 'completed').length) return false;
  return true;
}

function checkProjectActionsOnInterval(projectIdToDeploy, setDeploymentStatus) {
  apiService
    .listProjectActions(projectIdToDeploy)
    .then((answer) => {
      if (checkActionsStatus(answer.data.actions)) setDeploymentStatus('settled');
      else setDeploymentStatus('loading');
    })
    .catch((error) => {
      setDeploymentStatus('settled');
      throw error;
    });
}

const Spinner = ({ projectIdToDeploy, setDeploymentStatus }) => {
  useEffect(() => {
    let timerId;
    if (projectIdToDeploy)
      timerId = setInterval(
        () => checkProjectActionsOnInterval(projectIdToDeploy, setDeploymentStatus),
        10000
      );
    return () => {
      if (timerId) clearInterval(timerId);
    };
  }, [projectIdToDeploy]);
  return <div id="cover-spin3" />;
};

const CancelButton = ({selectedProject}) => {
    const navigate = useNavigate();
    
    return (
    <button
    type="button"
    className={clsx('cleanCssButton', 'teamselector')}
    onClick={() => {
        navigate('/build_apps', {
            state: {
                name: JSON.parse(localStorage.getItem('data'))[selectedProject].name,
                reason: 'backToBuildApps'
            }
          });
    }}
    style={{
      color: '#0c4d82',
      border: '0.2rem solid #0c4d82',
      borderRadius: '0.5rem',
      width: '75%'
    }}
  >
    Cancel
  </button>
  );
};
